import { useLocale } from 'hooks';
import { useI18n } from 'locales';
import moment from 'moment-timezone';

export function TranslatedText({ value }) {
  const t = useI18n();
  const locale = useLocale();

  return locale === 'en' ? t(value).charAt(0).toUpperCase() + t(value).slice(1) : t(value);
}

export function dateTimeToISOString(date) {
  return date ? moment.tz(date, 'Asia/Hong_Kong').toISOString() : null;
}

export function dateTimeToString(date) {
  return date ? moment.tz(date, 'Asia/Hong_Kong').format('DD/MM/YYYY HH:mm:ss') : null;
}

export function dateToString(date) {
  return date ? moment.tz(date, 'Asia/Hong_Kong').format('DD/MM/YYYY') : null;
}

export function uncapitalize(input) {
  return input.charAt(0).toLowerCase() + input.slice(1);
}

export function pcgidToString(pcgid) {
  if (pcgid == null) return null;
  return pcgid.toString().padStart(4, '0');
}

export function convertEmptyStringToNull(obj) {
  const _convertEmptyStringToNull = (obj) => {
    for (const key in obj) {
      if (typeof obj[key] === 'object') {
        obj[key] = _convertEmptyStringToNull(obj[key]);
      } else if (obj[key] === '') {
        obj[key] = null;
      }
    }
    return obj;
  };

  return _convertEmptyStringToNull(JSON.parse(JSON.stringify(obj)));
}

export function localizeFund(fund, locale) {
  if (!fund) return;
  if (Object.entries(fund).length === 0) return;

  switch (locale) {
    case 'zh-Hant':
      return fund.nameChi ?? fund.nameEng ?? '-';
    case 'zh-Hans':
      return fund.nameSimplifiedChi ?? fund.nameEng ?? '-';
    default:
      return fund.nameEng ?? '-';
  }
}
